import CheckIcon from "@icons/CheckIcon.svg?react";
import { SvgImageSwap } from "../../../display-items/SVGIcon";

function FinishButton({ onClick }: { onClick: any }) {
  return (
    <button className="iconButton__alt bg_green300" onClick={onClick}>
      <SvgImageSwap
        src={CheckIcon}
        alt="Finish Icon"
        className="icon fill_green_800"
      />
    </button>
  );
}

export default FinishButton;
